import Vue from 'vue';
import moment from 'moment';
import accounting from 'accounting';

Vue.filter('moment', (val, fmt) => {
  fmt = fmt ?? 'MM/DD/YYYY';

  return moment(val).format(fmt);
})

Vue.filter('momentUtc', (val, fmt) => {
  fmt = fmt ?? 'MM/DD/YYYY';

  return moment.utc(val).format(fmt);
})

Vue.filter('formatNumber', (val, toFixed) => {

  return accounting.formatNumber(val, toFixed);
})

Vue.filter('formatMoney', (val, toFixed) => {
  return accounting.formatMoney(val, toFixed);
})
